/**
 * Analytics data is captured ONLY on the production app. Feature flags still
 * resolve everywhere (same SDK) — this gates what we SEND, not what we read.
 * Staging, Pages preview deployments (*.pages.dev), and localhost keep working
 * flags but emit no events, pageviews, replays, exceptions, or person
 * properties. The one exception is the SDK's own $identify, which flags need
 * for per-user targeting.
 *
 * Two production hostnames while the product moves from vertice.finance to
 * unare.finance (VER-479): the old one redirects to the new one once Clerk's
 * primary domain has moved, and leaves this list with it.
 */
export const PRODUCTION_HOSTNAMES: ReadonlySet<string> = new Set([
  'app.vertice.finance',
  'app.unare.finance',
]);

export function isCaptureAllowed(
  hostname: string = typeof window !== 'undefined' ? window.location.hostname : '',
): boolean {
  return PRODUCTION_HOSTNAMES.has(hostname);
}
